(() => {
  const footer = document.querySelector('[data-common-footer]');
  if (!footer || footer.dataset.trackingReady === 'true') return;
  footer.dataset.trackingReady = 'true';

  const pageType = footer.dataset.pageType || 'other';
  const pushEvent = payload => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  footer.addEventListener('click', event => {
    const link = event.target.closest('a[data-footer-link]');
    if (!link || !footer.contains(link)) return;
    pushEvent({
      event: 'footer_click',
      footer_group: link.dataset.footerGroup,
      link_brand: link.dataset.linkBrand,
      link_label: link.dataset.linkLabel,
      destination: link.dataset.destination,
      position_in_group: Number(link.dataset.positionInGroup),
      page_type: pageType
    });
  }, true);

  const sessionKey = 'mebore_footer_view_v1';
  try {
    if (window.sessionStorage.getItem(sessionKey) === '1') return;
  } catch (_) {
    // Continue without session deduplication when storage is unavailable.
  }

  let viewTimer;
  const observer = new IntersectionObserver(entries => {
    const entry = entries[0];
    window.clearTimeout(viewTimer);
    if (!entry?.isIntersecting || entry.intersectionRatio < .5) return;
    viewTimer = window.setTimeout(() => {
      pushEvent({ event: 'footer_view', page_type: pageType });
      try { window.sessionStorage.setItem(sessionKey, '1'); } catch (_) { /* noop */ }
      footer.dataset.footerViewSent = 'true';
      observer.disconnect();
    }, 1000);
  }, { threshold: [.5] });
  observer.observe(footer);
})();
